import * as React from 'react';
import { NavRoot, LogoStyled } from './NavStyle.js'
import LOGO from 'assets/images/Me-facturo.png'
function Nav() {
   return ( 
      <NavRoot >
         <LogoStyled src={LOGO} alt="Logo" />
      </NavRoot>
    );
}

export default Nav;